import { render } from "./a-side-menu.vue?vue&type=template&id=30139953&scoped=true"
import script from "./a-side-menu.vue?vue&type=script&lang=js"
export * from "./a-side-menu.vue?vue&type=script&lang=js"

import "./a-side-menu.vue?vue&type=style&index=0&id=30139953&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30139953"]])

export default __exports__